import { useDispatch, useSelector } from 'react-redux'
import { usePostApiV1AccountsPasswordRecoverChangeMutation } from '../../../../authApi'
import { authSlice } from '../../../../authSlice'
import { SubmitHandler } from 'react-hook-form'
import { logger } from 'helpers/logger'
import { type RegisterInput } from '.'

export const useSubmit = () => {
  const dispatch = useDispatch()
  const fields = useSelector(authSlice.selectors.selectForgotPasswordFields)
  const [changePassword, { isLoading }] =
    usePostApiV1AccountsPasswordRecoverChangeMutation()

  const onSubmit: SubmitHandler<RegisterInput> = async ({ newPassword }) => {
    if (!fields?.login) return
    try {
      await changePassword({
        passwordRecoveryChange: {
          newPassword,
          login: fields.login,
        },
      }).unwrap()
      dispatch(authSlice.actions.setForgotPasswordStep('login'))
    } catch (error) {
      logger.error('Submit forgot password confirm error: ', error)
    }
  }

  return { onSubmit, isLoading }
}
